<template>
  <modal
    :show="true"
    :large="true"
    v-on:close="closeVulnerabilityModal"
    :enable-event="!alertIsOpen"
  >
    <h4 slot="title">Edit Vulnerability</h4>
    <div class="row">
      <fieldset
        :disabled="readonly"
        style="border:0;padding:0;margin:0;min-width:0;"
      >
        <div class="col-xl-12">
          <div class="form-horizontal">
            <selectlist
              name="vulnerability_consent_method_id"
              :options="vulnerabilityConsentMethods"
              v-model="form.vulnerability_consent_method_id"
              label="Consent Method"
              placeholder="Please Select"
              helper="Please select the vulnerability consent method"
              :error-message="
                form.errors.get('vulnerability_consent_method_id')
              "
              :show-error="form.errors.has('vulnerability_consent_method_id')"
            ></selectlist>

            <selectlist
              :options="vulnerabilityCodes"
              v-model="form.vulnerability_code_id"
              label="Vulnerability Code"
              name="vulnerability_code_id"
              helper="Please select the vulnerability Code"
              :error-message="form.errors.get('vulnerability_code_id')"
              :show-error="form.errors.has('vulnerability_code_id')"
            ></selectlist>

            <input-block
              v-model="form.information_provided"
              name="information_provided"
              label="Information Provided"
              helper="Please enter the information client has provided about their vulnerability"
              :error-message="form.errors.get('information_provided')"
              :show-error="form.errors.has('information_provided')"
            ></input-block>

            <input-block
              v-model="form.support_required"
              name="support_required"
              label="Support Required"
              helper="Please enter the support the client requires"
              :error-message="form.errors.get('support_required')"
              :show-error="form.errors.has('support_required')"
            ></input-block>

            <input-block
              v-model="form.support_provided"
              name="support_provided"
              label="Support Provided"
              helper="Please enter the details of the support we have provided for the client"
              :error-message="form.errors.get('support_provided')"
              :show-error="form.errors.has('support_provided')"
            ></input-block>
          </div>
        </div>
      </fieldset>
    </div>
    <div slot="footer">
      <div class="float-left">
        <form-button
          :indicator="indicator"
          v-on:clicked="deleteVulnerability"
          level="danger"
          v-if="!readonly"
          >Delete</form-button
        >
      </div>
      <button
        type="button"
        v-on:click="closeVulnerabilityModal"
        class="btn btn-danger"
      >
        Close
      </button>
      <form-button
        v-if="!readonly"
        :indicator="form.processing()"
        v-on:clicked="updateVulnerability"
        >Update Vulnerability</form-button
      >
    </div>
  </modal>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    vulnerabilityConsentMethods: {
      type: Array,
      required: true
    },

    vulnerabilityCodes: {
      type: Array,
      required: true
    },

    vulnerability: {
      type: Object,
      required: true
    },

    client: {
      type: Object
    }
  },

  data() {
    return {
      alertIsOpen: false,
      form: new window.Form({
        vulnerability_consent_method_id: this.vulnerability
          .vulnerability_consent_method_id,
        vulnerability_code_id: this.vulnerability.vulnerability_code_id,
        information_provided: this.vulnerability.information_provided,
        support_required: this.vulnerability.support_required,
        support_provided: this.vulnerability.support_provided
      }),
      indicator: false
    };
  },

  computed: {},

  methods: {
    deleteVulnerability() {
      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You cannot undo this',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.indicator = true;
            window.Ajax.delete(
              '/incidents/' +
                this.incident +
                '/client/' +
                this.client.identifier +
                '/vulnerability/' +
                this.vulnerability.identifier
            )
              .then(response => {
                this.$emit('deleted', this.vulnerability);
                this.indicator = false;
              })
              .catch(error => {
                this.indicator = false;
                window.toastify.error(
                  'Error',
                  'Sorry, there was an error deleting the vulnerability.'
                );
              });
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    closeVulnerabilityModal() {
      if (this.readonly) {
        this.$emit('close');
        return;
      }

      this.alertIsOpen = true;

      window
        .swal({
          title: 'Are you sure?',
          text: 'You will lose any unsaved changes',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then(confirmed => {
          if (confirmed) {
            this.$emit('close');
          }
        })
        .catch(error => {
          setTimeout(() => {
            this.alertIsOpen = false;
          }, 500);
        });
    },

    updateVulnerability() {
      this.form
        .put(
          '/incidents/' +
            this.incident +
            '/client/' +
            this.client.identifier +
            '/vulnerability/' +
            this.vulnerability.identifier
        )
        .then(response => {
          this.$emit('updated', response);
        })
        .catch(response => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error updating the vulnerability'
          );
        });
    }
  }
};
</script>
